
import React from "react";
import Dashboard from "../Components/Admin/Dashboard";
import Login from "../Components/Admin/Login";
import CreateTeam from "../Components/Admin/OurTeamCreate/Create-team";
import AdminLayout from "../Components/SideBar/Layout";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import CaseAdmin from "../Components/Admin/CaseStudyCreate/CaseAdminCreate";
import BlogCreate from "../Components/Admin/BlogCreate/BlogCreate";
import CareerPage from "../Components/Admin/CareerPage/CareerPage";
import Query from "../Components/Admin/Query";

import PaymentGet from "../Components/Admin/PaymentGet";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  console.log("PrivateRoute - isAuthenticated:", isAuthenticated, "loading:", loading);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    console.log("Not authenticated, redirecting to login");
    return <Navigate to="/admin/login" replace />;
  }
  
  console.log("Authenticated, showing protected route");
  return children;
};

const AdminRoutes = () => {
  const { isAuthenticated, loading } = useAuth();
  
  console.log("AdminRoutes - isAuthenticated:", isAuthenticated, "loading:", loading);
  
  return (
    <Routes>
      {/* Public admin route - login */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected admin routes - all require authentication */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      
      <Route
        path="/create-team"
        element={
          <PrivateRoute>
            <AdminLayout>
              <CreateTeam />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      
      <Route
        path="/create-case-study"
        element={
          <PrivateRoute>
            <AdminLayout>
              <CaseAdmin />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      
      <Route
        path="/create-blog"
        element={
          <PrivateRoute>
            <AdminLayout>
              <BlogCreate />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      
      <Route
        path="/query"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Query />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment"
        element={
          <PrivateRoute>
            <AdminLayout>
              <PaymentGet />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/create-career"
        element={
          <PrivateRoute>
            <AdminLayout>
              <CareerPage />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      
      {/* Default redirect for admin routes */}
      <Route 
        path="/" 
        element={<Navigate to="/admin/login" replace />} 
      />
      
      <Route 
        path="*" 
        element={<Navigate to="/admin/login" replace />} 
      />
    </Routes>
  );
};

export default AdminRoutes;